import {
    HOMEPAGE_SETTINGS_UPLOAD_START,
    HOMEPAGE_SETTINGS_UPLOAD_ERROR,
    HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index'
import { setLoaderStart, setLoaderComplete } from '../loader/loader'
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateHomePageHomeMutation as mutation } from '../../lib/graphql';

export const updateHomepageSettingsHome = (values) => {

    return async (dispatch, getState, { client }) => {

        try {
            dispatch(setLoaderStart('HomeSettingsForm'));
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_START
            })
            const { data } = await client.mutate({
                mutation,
                variables: {
                    homeSectionImage1: values?.homeSectionImage1,
                    homeSectionImage2: values?.homeSectionImage2,
                    homeSectionImage3: values?.homeSectionImage3,
                    homeSectionImage4: values?.homeSectionImage4,
                    homeSectionImage5: values?.homeSectionImage5,
                    homeSectionImage6: values?.homeSectionImage6,
                    homeSectionImage7: values?.homeSectionImage7,
                    homeSectionImage8: values?.homeSectionImage8,
                    homeSectionButton1: values?.homeSectionButton1,
                    homeSectionTitle1: values?.homeSectionTitle1 && values?.homeSectionTitle1[0].value,
                    dynamicHomeBannerTitle: values?.homeSectionTitle1
                }
            })

            if (data?.updateHomePageHome?.status == 200) {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
                });
                showToaster({ messageId: 'updateFooterSuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
                })
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateHomePageHome?.errorMessage }, toasterType: 'error' });
            }
            dispatch(setLoaderComplete('HomeSettingsForm'));
        } catch (err) {
            dispatch(setLoaderComplete('HomeSettingsForm'));
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
            })
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
        }
    }
}